import { render, staticRenderFns } from "./CoffeeMakerFields.vue?vue&type=template&id=0cb48b78&scoped=true"
import script from "./CoffeeMakerFields.vue?vue&type=script&lang=js"
export * from "./CoffeeMakerFields.vue?vue&type=script&lang=js"
import style0 from "./CoffeeMakerFields.vue?vue&type=style&index=0&id=0cb48b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb48b78",
  null
  
)

export default component.exports